package one.healthium.ui.compose.components.cupertino

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.ui.text.intl.Locale

actual typealias CalendarLocale = Locale

@Composable
@ReadOnlyComposable
actual fun defaultLocale(): CalendarLocale = Locale.current

actual fun currentLocale(): CalendarLocale = Locale.current
